import { render, staticRenderFns } from "./MyLeadsTable.vue?vue&type=template&id=2559b23e&scoped=true&"
import script from "./MyLeadsTable.vue?vue&type=script&lang=js&"
export * from "./MyLeadsTable.vue?vue&type=script&lang=js&"
import style0 from "./MyLeadsTable.vue?vue&type=style&index=0&id=2559b23e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2559b23e",
  null
  
)

export default component.exports